export default __webpack_public_path__ + "locales/fr/Errors.json?hash=2ea07760da4d5689e904e3215036176d";